import { InjectionToken } from '@angular/core';

export const UI_ANCHOR_LINK_DISTANCE = new InjectionToken<string>('UI_ANCHOR_LINK_DISTANCE');